import { rankingGames } from "@/mocks/erogeData";

export default function Ranking() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm mb-2">
              <i className="ri-trophy-line" />
              RANKING
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">
              工口游戏排行榜
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-xl leading-7">
              综合剧情、美术、音乐、口碑与社区热度，整理出近期最值得玩的工口游戏口碑榜，排名实时更新。
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-500/15 text-secondary-400 text-xs whitespace-nowrap">
              <i className="ri-fire-line" /> 本周热榜
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {rankingGames.map((g, idx) => (
            <article
              key={g.id}
              className="group flex flex-col sm:flex-row gap-4 md:gap-5 rounded-xl bg-background-100/50 border border-background-200/60 p-3 md:p-4 hover:border-primary-500/40 hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => go("#reviews")}
            >
              <div className="flex items-center gap-4 sm:w-56 md:w-64 shrink-0">
                <span
                  className={`font-heading text-3xl md:text-4xl w-10 text-center shrink-0 ${
                    idx === 0 ? "text-accent-400" : idx === 1 ? "text-secondary-400" : "text-foreground-600"
                  }`}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="relative w-24 md:w-28 h-20 md:h-24 rounded-lg overflow-hidden shrink-0">
                  <img src={g.image} alt={`${g.title} 工口游戏排行榜第${idx + 1}名封面`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  {idx < 3 && (
                    <span className="absolute top-1 left-1 w-5 h-5 rounded-full bg-accent-500/90 text-foreground-950 text-[10px] flex items-center justify-center">
                      <i className="ri-medal-line" />
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-3 md:gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950 whitespace-nowrap">{g.title}</h3>
                    <span className="px-2 py-0.5 rounded-md bg-primary-500/15 text-primary-400 text-[11px]">{g.type}</span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1">{g.category} · {g.year} · {g.studio}</p>
                  <p className="text-xs md:text-sm text-foreground-600 mt-1 leading-6 hidden sm:block">{g.desc}</p>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {g.tags.map((t) => (
                      <span key={t} className="px-2 py-0.5 rounded-md bg-background-200/60 text-foreground-500 text-[11px]">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-4 shrink-0">
                  <div className="text-center">
                    <p className="font-heading text-2xl md:text-3xl text-accent-400">{g.rating}</p>
                    <p className="text-[11px] text-foreground-500">口碑分</p>
                  </div>
                  <span className="w-8 h-8 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-500 group-hover:text-primary-500 transition-colors">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}